/* Cartwala inline quantity and photo-gallery Edit Again action */
(function () {
  "use strict";
  if (window.__cwProductUX) return;
  window.__cwProductUX = true;

  function init() {
    var main = document.querySelector("main#MainContent") || document.querySelector("main");
    if (!main) return;
    var form = main.querySelector("form[data-main-add-to-cart]");
    var gallery = main.querySelector("[data-gallery-main].product-gallery__main");
    var row, qtyGroup, addButton, overlay, source;
    var pending = false;

    if (form) {
      addButton = form.querySelector("[data-add-to-cart]");
      var qty = form.querySelector('input[name="quantity"]');
      qtyGroup = qty && qty.closest(".variant-group");
      if (addButton && qtyGroup && !form.querySelector(".cw-product-buy-row")) {
        row = document.createElement("div");
        row.className = "cw-product-buy-row";
        qtyGroup.parentNode.insertBefore(row, qtyGroup);
        row.appendChild(qtyGroup);
        row.appendChild(addButton);
        qtyGroup.classList.add("cw-ux-quantity-group");
      } else {
        row = form.querySelector(".cw-product-buy-row");
      }
    }

    function createOverlay() {
      if (!gallery || overlay) return;
      overlay = document.createElement("button");
      overlay.type = "button";
      overlay.className = "cw-ux-edit-overlay";
      overlay.hidden = true;
      overlay.setAttribute("aria-label", "Edit your saved personalisation");
      overlay.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L10 16l-4 1 1-4z"/></svg><span>Edit Again</span>';
      overlay.addEventListener("click", function (event) {
        event.preventDefault();
        if (source && source.isConnected && !source.disabled) source.click();
      });
      gallery.appendChild(overlay);
    }

    function findEditSource() {
      var roots = Array.prototype.slice.call(document.querySelectorAll(
        '[data-cw-personalizer], [data-cw-gift-personalizer]'
      ));
      var native = roots.map(function (root) {
        if (root.dataset.cwUxEditListener !== "yes") {
          root.dataset.cwUxEditListener = "yes";
          root.addEventListener("cartwala:preview-ready", schedule);
        }
        return root.querySelector("[data-cw-open]");
      }).filter(Boolean);
      var all = native.concat(Array.prototype.slice.call(main.querySelectorAll(
        '[data-personalize-open], [data-customize-now], .cw-personalizer__open'
      )));
      var completed = !!form && Array.prototype.some.call(form.querySelectorAll(
        "input[name^='properties[']"
      ), function (field) {
        return /_Cartwala Personalization/i.test(field.name) &&
          /completed/i.test(field.value || "");
      });
      return all.find(function (button) {
        if (button === overlay || button.disabled ||
            button.closest("dialog, [role='dialog'], .cw-single-action-footer") ||
            button.closest("[hidden]")) return false;
        var label = (button.textContent || "").trim();
        return /^(?:✎\s*)?edit again$/i.test(label) || 
          (completed && button.hasAttribute("data-cw-open"));
      }) || null;
    }

    function actionAvailable() {
      if (!addButton || addButton.hidden || addButton.closest("[hidden]")) return false;
      var style = window.getComputedStyle(addButton);
      return style.display !== "none" && style.visibility !== "hidden" &&
        addButton.getClientRects().length > 0 && !addButton.disabled;
    }

    function update() {
      pending = false;
      if (row) {
        var ready = actionAvailable();
        if (row.classList.contains("cw-main-atc-ready") !== ready)
          row.classList.toggle("cw-main-atc-ready", ready);
      }
      // Mug 3D swaps the gallery contents asynchronously; always acquire the live host.
      var liveGallery = main.querySelector("[data-gallery-main].product-gallery__main") ||
        main.querySelector(".cw-mug-gallery-host") ||
        main.querySelector("[data-product-gallery]");
      if (gallery !== liveGallery) {
        if (overlay) { overlay.remove(); overlay = null; }
        gallery = liveGallery;
      }
      if (!gallery) return;
      createOverlay();
      // Mug preview is appended later and used to cover the original photo; keep the
      // Edit Again overlay above it, without removing the 3D preview or its controls.
      if (overlay && gallery.lastElementChild !== overlay) gallery.appendChild(overlay);
      var found = findEditSource();
      if (source && source !== found && source.classList.contains("cw-ux-edit-source-hidden"))
        source.classList.remove("cw-ux-edit-source-hidden");
      source = found;
      if (source && !source.classList.contains("cw-ux-edit-source-hidden"))
        source.classList.add("cw-ux-edit-source-hidden");
      var showEdit = !!source;
      if (overlay.hidden === showEdit) overlay.hidden = !showEdit;
    }

    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }
    var mo = new MutationObserver(schedule);
    mo.observe(main, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class", "hidden", "style", "disabled"]
    });
    window.addEventListener("resize", schedule, {passive:true});
    document.addEventListener("shopify:section:load", schedule);
    document.addEventListener("cartwala:personalization-saved", schedule);
    update();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();